export const isViewableBySponsor = (event: NQTEvent) => event.forParrainActive
export const isViewableByYoung = (event: NQTEvent) => event.forJeuneFollowed
